import { ZealApiSuccessResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IPostServiceTypeArgs,
  IPostServiceTypeResponseData,
} from "./postServiceType.schema";

type SuccessResponse = ZealApiSuccessResponse<IPostServiceTypeResponseData>;

export const postServiceType = (axios: IAxiosInstance) => {
  return async (params: IPostServiceTypeArgs) => {
    try {
      const response = await axios.noRetry.post<SuccessResponse>(
        `/service-types`,
        params
      );
      return response?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
